import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CookieService } from '../_services/cookie.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private _cookieService: CookieService) { }

    // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    //     let cookie: any = this._cookieService.getCookie('ussr');

    //     if (cookie) {
    //         // logged in so return true
    //         return true;
    //     }

    //     const fullUrl = state.url; // relative URL (e.g., "/irmnch/account")

    //     const origin = window.location.origin; // e.g., "http://localhost:4200"
    //     const fullAbsoluteUrl = `${origin}${state.url}`;
    //     // not logged in so redirect to login page with the return url
    //     let url = state.url;
    //     if (state.url == '/dashboard') {
    //         this.router.navigate(['/account/login']);
    //     } else if (fullAbsoluteUrl.includes('https://mnhc.pshealthpunjab.gov.pk/irmnch/account')) {
    //         window.location.href = 'https://admin-mnhc.pshealthpunjab.gov.pk/account/login';
    //     }
    //     else {
    //         this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
    //     }
    //     return false;
    // }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // debugger;
        const cookie: any = this._cookieService.getCookie('ussr');
        const currentUrl = state.url;
        const currentHost = window.location.host;

        const isAdminDomain = currentHost === 'admin-mnhc.pshealthpunjab.gov.pk';
        const isMainDomain = currentHost === 'mnhc.pshealthpunjab.gov.pk';

        if (cookie) {
            return true;
        }

        // If user is on main domain's login page → redirect to admin domain
        if (isMainDomain && currentUrl === '/account/login') {
            window.location.href = 'https://admin-mnhc.pshealthpunjab.gov.pk/account/login';
            return false;
        }

        // If already on admin domain login → do nothing, stay on page
        if (isAdminDomain && currentUrl === '/account/login') {
            return true;
        }

        // Default redirect to /account/login (on the same domain)
        this.router.navigate(['/account/login'], { queryParams: { returnUrl: currentUrl } });
        return false;
    }
}